export default "__VITE_ASSET__0b4a336c__"